import { SVGProps } from 'react'
const UsersIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    fill="none"
    {...props}
  >
    <path
      fill={props.fill || '#fff'}
      d="M9.999 10.648a4.167 4.167 0 1 0 0-8.333 4.167 4.167 0 0 0 0 8.333ZM10 12.732c-4.174 0-7.574 2.8-7.574 6.25 0 .233.183.417.416.417H17.16a.413.413 0 0 0 .417-.417c0-3.45-3.4-6.25-7.575-6.25Z"
    />
  </svg>
)
export default UsersIcon
